<template>
  <div class="service">
    <van-nav-bar
      title="服务"
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="center">
      <div class="main-box">
        <div class="top">
          <div class="main" v-for="item in mainArr" :key="item.title" @click="onSkip(item)">
            <img :src="item.src" alt="" srcset="">
            <van-cell-group inset>
              <van-cell :title="item.title" :label="item.label" value-class="text-class" is-link/>
            </van-cell-group>
          </div>
        </div>
        <div class="btm">
          <img src="../assets/fu-wu/tall.png" alt="" style="height: 80%">
          <div>以上服务由北京市燃气集团有限责任公司提供</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Service',
    data () {
      return {
        mainArr: [
          {
            src: require('../assets/fu-wu/fu-wu-1.png'),
            title: '查询',
            label: '查询北京燃气集团管辖范围内所属用户的地址、表型、近12个月的充值缴费记录信息。',
            name: 'accountInformation'
          },
          {
            src: require('../assets/fu-wu/fu-wu-2.png'),
            title: '发票',
            label: '对北京燃气集团管辖范围内所有普表（后付费）用户进行发票开具，暂不支持预付费表具开票。',
            name: 'Bill'
          },
          {
            src: require('../assets/fu-wu/fu-wu-3.png'),
            title: '报修',
            label: '提供对北京燃气集团管辖范围内所属用户燃气表、管道阀门、燃气设备的报修业务及拆改迁的个性化服务。',
            name: 'Repair'
          }
        ]

      }
    },
    mounted() {
      let title = this.$route.query.title;
      this.$router.push({ path: '/accountNumberManagement', query: { title: title } })
    },
    methods: {
      // 路由跳转
      onSkip (val) {
        /*if (val.title === '发票') {
          if (this.$store.state.cardObj.meterType !== 'R') {
            this.$toast.fail('仅普表用户才可以开票')
            return
          }
        }
        this.$router.push({
          name: val.name
        })*/
        // window.localStorage.pageTitle = val.title
        this.$router.push({ path: '/accountNumberManagement', query: { title: val.title } })
      },
      onClickLeft () {
        this.$router.go(-1)
      }

    }
  }
</script>

<style scoped>
  .service {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-image: url('../assets/bj.png');
    background-repeat: no-repeat;
    background-size: 100%;
  }

  .service >>> .van-nav-bar {
    background: none;
  }

  .center {
    width: 100%;
    height: calc(100% - 220px);
    padding: 0 20px;
    box-sizing: border-box;
    text-align: center;
  }

  .main-box {
    width: 100%;
    height: 93%;
    border-radius: 8px;
    background: #fff;
    box-shadow: 0px 0px 18px rgba(7, 15, 86, 0.1);
    padding: 20px;
    box-sizing: border-box;
  }

  .top {
    width: 100%;
    height: 70%;
  }

  .btm {
    width: 100%;
    height: 30%;
  }

  .main-box > div {
    color: #999;
    font-size: 12px;
  }

  .main {
    width: 100%;
    height: 33%;
    display: flex;
    align-items: center;
  }

  .main > img {
    width: auto;
    height: 80%;
  }

  .main >>> .van-cell-group--inset {
    height: 100%;
    margin: 0;
  }

  .main >>> .van-cell {
    padding: 0;
    height: 100%;
  }

  .main >>> .van-cell__title {
    text-align: left;
    padding-left: 30px;
    box-sizing: border-box;
  }

  .main >>> .van-cell__title span {
    font-size: 16px;
    font-weight: 600;
    color: #27282E;
  }
</style>
